/**
 * F-60 entry point: the "Arrange script" icon in the F-27 selection toolbar
 * (docs/08 §2 — one `registerToolbarAction` call; the toolbar never
 * special-cases it).
 *
 * VISIBLE only when the selection is a single column AND that column is the
 * F-28 locked "Original Script" column — the exact complement of the translate
 * icon (which shows on every column BUT the source), so the two never share a
 * pill. Always enabled when visible: whether the selected cells actually have
 * anything to split is the preview dialog's answer (segmenting every selected
 * cell inside `enabled()` would run per toolbar render — at a 10k-row column
 * selection that is real work for a boolean).
 */
import {
  registerToolbarAction,
} from "../../registries/toolbar-actions/index.js";
import { arrangeUi } from "./store.js";

const svgProps = {
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
} as const;

/** One long row splitting into stacked rows (an arrow through the break). */
const iconArrange = (
  <svg {...svgProps} aria-hidden="true">
    <path d="M2.5 3h11" />
    <path d="M2.5 8h5.5" />
    <path d="M2.5 13h5.5" />
    <path d="M12 6.5v5" />
    <path d="m10 9.7 2 1.8 2-1.8" />
  </svg>
);

registerToolbarAction({
  id: "arrange-script",
  appliesTo: "cells",
  tooltip: "Arrange script — one sentence per row (words never change)",
  order: 20, // the translate icon's slot; the two are visible on disjoint columns
  icon: iconArrange,
  visible: (ctx) => {
    const sel = ctx.selection;
    if (sel.kind !== "cells" || sel.colIds.length !== 1) return false;
    const colId = sel.colIds[0];
    if (colId === undefined) return false;
    const sourceColId = ctx.session.board.sourceColumnId(sel.sheetId);
    return sourceColId !== undefined && colId === sourceColId;
  },
  run: (ctx) => {
    const sel = ctx.selection;
    if (sel.kind !== "cells") return;
    const colId = sel.colIds[0];
    if (colId === undefined) return;
    arrangeUi.getState().openDialog({
      boardId: ctx.session.boardId,
      sheetId: sel.sheetId,
      colId,
      rowIds: sel.rowIds,
    });
  },
});
